/**
 * Tynd amber-strip, der vises overalt, mens "Skjul priser" er slået til —
 * så man aldrig er i tvivl om tilstanden, og kan slå den fra med ét tryk.
 */
import { EyeOff } from "lucide-react";
import { usePriceVisibility } from "@/features/catalog/PriceVisibilityContext";

export function HiddenPricesBanner() {
  const { hidePrices, setHidePrices } = usePriceVisibility();
  if (!hidePrices) return null;
  return (
    <div className="flex min-h-10 items-center justify-center gap-3 bg-amber-500 px-3 py-1.5 text-sm font-medium text-amber-950">
      <span className="flex items-center gap-1.5">
        <EyeOff className="h-4 w-4" aria-hidden />
        Priser er skjult
      </span>
      <button
        type="button"
        onClick={() => setHidePrices(false)}
        className="rounded-md bg-amber-950/10 px-2.5 py-1 text-xs font-bold underline-offset-2 hover:underline"
      >
        Vis priser
      </button>
    </div>
  );
}
